import React from 'react'

interface CustomSwitchProps {
  checked?: boolean
  onChange: (checked: boolean) => void
  onIcon?: React.ReactNode
  offIcon?: React.ReactNode
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  checked,
  onChange,
  onIcon,
  offIcon,
}) => {
  const handleToggle = () => {
    onChange(!checked)
  }

  return (
    <div
      role='switch'
      aria-checked={checked}
      tabIndex={0}
      onClick={handleToggle}
      className={`relative w-[62px] h-[32px] flex items-center rounded-radius-full cursor-pointer transition-all duration-300 ${
        checked ? 'bg-primary' : 'border border-primary-foreground'
      }`}
    >
      <div
        className={`absolute left-1 text-lg transition-opacity duration-300 ${
          checked ? 'opacity-100' : 'opacity-0'
        }`}
      >
        {offIcon}
      </div>

      <div
        className={`absolute right-1 text-lg transition-opacity duration-300 ${
          checked ? 'opacity-0' : 'opacity-100'
        }`}
      >
        {onIcon}
      </div>

      <div
        className={`absolute w-[15px] h-[15px] rounded-radius-full bg-primary-foreground shadow-md transform transition-all duration-300 ${
          checked ? 'translate-x-9' : 'translate-x-1'
        }`}
      />
    </div>
  )
}

export default CustomSwitch
